import React from "react";
import { useHistory } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import { Icon, Image } from 'semantic-ui-react'
import userImage from '../../assets/img/NewProfileImage.png';
import logo from '../../assets/upgrade-images/logo.svg'
import mobile_logo from '../../assets/upgrade-images/mobile_logo.svg'
import { useDispatch, useSelector } from 'react-redux';
import manu from '../../assets/upgrade-images/menu.svg'
import { redirectTo } from "../../Components/routes/redirectToPath";
import { togglePopup, toggleSidebar } from "../../Actions/componentActions";
import universityLogo from '../../assets/upgrade-images/university-logo.svg'

export default function CommonHeader({ hasSideBar }) {
    const profileDetail = useSelector(state => (state.profileReducer.profileDetail));
    const isToggle = useSelector(state => state.componentReducer.isToggle)
    const history = useHistory()
    const dispatch = useDispatch()
    let userRole = profileDetail?.data?.user?.role

    const handleOnLogoClick = () => {
        let redirectUrl = redirectTo[userRole]
        history.push(redirectUrl)
    }

    const handleMenuClick = () => {
        dispatch(toggleSidebar(!isToggle))
    }

    const handleProfileClick = () => {

        dispatch(togglePopup({ open: true, type: 'Profile', crossIcon: false, className: '', popUpPosition: 'top-[5.5rem] left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-4 md:right-12' }))

    }

    return (
        <div className="mx-auto h-20 flex justify-between items-center max-w-[calc(100vw-20rem)] dark:bg-gray-900">
            <div className="w-full flex justify-between items-center">
                <div className="logo flex items-center gap-2">
                    {hasSideBar &&
                        <button
                            id=""
                            onClick={handleMenuClick}
                            className="left-5 px-3 py-3.5 rounded-lg border transition-all duration-300 dark:bg-gray-800 dark:border-gray-700"
                        >
                            <img
                                className="w-full dark:invert"
                                src={manu}
                                loading="lazy"
                                alt="sidebar toggle"
                            />
                        </button>
                    }
                    <button className="" onClick={handleOnLogoClick}>
                        <img className="hidden md:block" loading="lazy" src={logo} alt="" />
                        <img className="md:hidden" loading="lazy" src={mobile_logo} alt="" />
                    </button>
                </div>



                <div className="nav flex gap-8">
                    <div className="nav-icons flex items-center md:gap-8">
                        <div>
                            {userRole?.includes('udc') &&
                                <img
                                    className="hidden dark:invert dark:grayscale transition-all duration-300 md:block"
                                    src={universityLogo}
                                    loading="lazy"
                                    alt=""
                                />
                            }
                        </div>
                        <div className="flex justify-between items-center pt-2 text-[1.25rem] font-bold cursor-pointer text-[#0f172a]" onClick={handleProfileClick}>
                            <Image
                                src={profileDetail?.data?.user?.user_image || userImage}
                                loading="lazy"
                                className="my-profile-img w-[50px] h-[50px] rounded-full object-cover"
                            />
                            <span className="ml-3 mr-1 text-[#0f172a] font-bold text-base select-none">
                                {profileDetail?.data?.user?.first_name 
                                    ? `${profileDetail.data.user.first_name} ${profileDetail.data.user.last_name || ''}`.trim()
                                    : sessionStorage.getItem("userName") || "Admin"}
                            </span>
                            <Icon className="caret down !text-[#0f172a] !opacity-100" style={{ color: '#0f172a', opacity: 1 }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
